'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (
      error.name === 'ChunkLoadError' ||
      error.message?.includes('Loading chunk') ||
      error.message?.includes('Failed to fetch dynamically imported module')
    ) {
      const reloadKey = `chunk_reload_${window.location.pathname}`;
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      if (!lastReload || now - parseInt(lastReload) > 10000) {
        sessionStorage.setItem(reloadKey, now.toString());
        window.location.reload();
        return;
      }
    }
  }, [error]);

  // 只显示错误码，不暴露任何技术细节
  const errorCodeMatch = error.message?.match(/E(\d{4})/);
  const errorCode = errorCodeMatch ? errorCodeMatch[0] : 'E1005';

  return (
    <html lang="zh-CN">
      <body>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: 'system-ui, sans-serif',
          background: '#0a0a0a',
          color: '#e5e5e5',
          padding: '2rem',
        }}>
          <div style={{
            maxWidth: '480px',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: '3rem', fontFamily: 'monospace', color: 'rgba(255,255,255,0.15)', marginBottom: '1rem' }}>
              {errorCode}
            </div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
              页面加载出现问题
            </h2>
            <p style={{ color: '#a3a3a3', marginBottom: '2rem', lineHeight: 1.6 }}>
              服务异常，请稍后重试。如问题持续，请联系管理员。
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '0.75rem 2rem',
                  background: '#2563eb',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.5rem',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
              >
                刷新页面
              </button>
              <button
                onClick={reset}
                style={{
                  padding: '0.75rem 2rem',
                  background: 'transparent',
                  color: '#a3a3a3',
                  border: '1px solid #333',
                  borderRadius: '0.5rem',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
              >
                重试
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
